import React from 'react';

import { asset } from '../../../lib/asset';
import { MobileHeader } from '../MobileHeader';
import { Screen, Centre, Mark } from './MobileLoader.styles';

export type MobileLoaderProps = {
  onSkip?: () => void;
};

/**
 * Mobile loading screen: near-black background, header chrome (progress + Skip)
 * and a large pulsing white Whitelabels.com mark slightly below centre. The mark is
 * the logo SVG used as a mask over white.
 */
export const MobileLoader = ({ onSkip }: MobileLoaderProps): React.ReactElement => {
  const mask = `url("${asset('logo-mark.svg')}")`;
  return (
    <Screen>
      <MobileHeader onSkip={onSkip} />
      <Centre>
        <Mark $mask={mask} />
      </Centre>
    </Screen>
  );
};

export default MobileLoader;
